'use client'
import { useState, useEffect } from 'react';
import { searchUsers } from '@/app/api';
import { TextInput } from './textInput';
import { Spinner } from './spinner';
import { SearchUser } from '@/types';
import { Button } from './button';

interface UserSearchInputProps {
    onSelectUser: (user: SearchUser) => void;
    userType: string
}

export function UserSearchInput({ onSelectUser, userType }: UserSearchInputProps) {
    const [searchText, setSearchText] = useState('');
    const [results, setResults] = useState<SearchUser[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (searchText.length < 2) {
            setResults([]);
            return;
        }
        const timer = setTimeout(async () => {
            setLoading(true);
            try {
                const data = await searchUsers(userType, { query: searchText });
                setResults(data.data || []);
            } catch (error) {
                console.log('Erro na busca:', error);
                setResults([]);
            } finally {
                setLoading(false);
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [searchText]);

    const handleSelectUser = (user: SearchUser) => {
        onSelectUser(user);
        setSearchText('');
        setResults([]);
    };

    return (
        <div className='relative w-full'>
            <div className="flex w-full">
                <TextInput
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder={"Buscar usuário (digite código ou nome)"}
                    className='w-full'
                />
            </div>

            {loading && <div className="absolute right-3 top-2"> <Spinner className='size-4 border-2' /> </div>}

            {results.length > 0 && (
                <div className="absolute border border-ochre_accent bg-light_secondary dark:bg-dark_secondary rounded-md shadow-lg w-full mt-1 p-3">
                    {results.map((user) => (
                        <Button
                            key={user.id}
                            onClick={() => handleSelectUser(user)}
                        >
                            <div className="font-medium">
                                <p>{user.code}{' - '}{user.userName}<span className='opacity-90'>{"("}{user.name}{")"}</span></p>
                            </div>
                        </Button>
                    ))}
                </div>
            )}

            {searchText.length >= 2 && results.length === 0 && !loading && (
                <div className="absolute z-10 border border-ochre_accent bg-light_secondary dark:bg-dark_secondary rounded-md shadow-lg w-full mt-1 p-3">
                    <p>Nenhum usuário encontrado</p>
                </div>
            )}
        </div>
    )
}